import { Close, KeyboardArrowLeft, Menu, Search } from "@mui/icons-material";
import {
	AppBar,
	Box,
	FormControl,
	IconButton,
	Input,
	InputAdornment,
	OutlinedInput,
	TextField,
	Toolbar,
	Typography,
	useScrollTrigger,
	useTheme,
	useMediaQuery,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import OnlineIcon from "assets/icons/online";
import OfflineIcon from "assets/icons/offline";
import { useNetworkStatus } from "hooks/useNetworkStatus";

const TopBar = ({
	enableBackToPrevPage,
	enableSearching = false,
	handleSearch,
	title: titleProps = "",
	colorInvert = false,
	titleIcon,
	titleAlign = "center",
	onMenuClick,
}: {
	enableBackToPrevPage: boolean;
	enableSearching?: boolean;
	handleSearch?: Function;
	title: string | React.ReactNode;
	colorInvert?: boolean;
	titleIcon?: React.ReactNode;
	titleAlign?: "left" | "center" | "right";
	onMenuClick?: () => void;
}) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("md"));
	const [mode, setMode] = React.useState<"normal" | "search">("normal");
	const navigate = useNavigate();
	const { isOnline } = useNetworkStatus();
	const triggerSearching = () => {
		if (mode === "search") {
			setMode("normal");
			handleSearch("");
		} else {
			setMode("search");
		}
	};
	const trigger = useScrollTrigger({
		disableHysteresis: true,
		threshold: 0,
	});

	return (
		<>
			<AppBar
				position={"fixed"}
				elevation={colorInvert ? 0 : 1}
				sx={{
					zIndex: 999,
					backgroundColor: colorInvert ? "transparent" : theme.palette.background.paper,
					color: colorInvert ? "common.white" : "text.primary",
				}}>
				<Toolbar
					disableGutters
					sx={{ justifyContent: "space-between", minHeight: "48px !important", p: 0, px: 0, py: 0 }}
				>
					<Box sx={{ display: "flex", alignItems: "center" }}>
						{!enableBackToPrevPage && onMenuClick && isMobile && (
							<IconButton
								sx={{ p: "10px", color: colorInvert ? "common.white" : "text.primary" }}
								onClick={onMenuClick}
							>
								<Menu />
							</IconButton>
						)}
						{enableBackToPrevPage && (
							<IconButton
								sx={{ p: "10px", color: "common.white" }}
								onClick={() => {
									navigate("/");
								}}>
								<KeyboardArrowLeft />
							</IconButton>
						)}
						{titleAlign === "left" && mode === "normal" && (
							<Box sx={{ display: "flex", alignItems: "center", gap: 1, pl: enableBackToPrevPage || (onMenuClick && isMobile) ? 0 : 2 }}>
								<Typography
									variant={"h6"}
									textAlign={isMobile ? "left" : "center"}
									color={colorInvert ? "common.white" : "text.primary"}>
									{titleProps}
								</Typography>
							</Box>
						)}
						{/* {trigger && titleIcon && (
							<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
								{titleIcon}
							</Box>
						)} */}
					</Box>

					{titleAlign === "center" && (
						<Box
							left="50%"
							position={"absolute"}
							sx={{ transform: "translateX(-50%)" }}>
							{mode === "normal" ? (
								<Box sx={{ display: "flex", alignItems: "left", justifyContent: "left", gap: 1 }}>
									<Typography
										variant={"h6"}
										textAlign={isMobile ? "left" : "center"}
										color={colorInvert ? "common.white" : "text.primary"}>
										{titleProps}
									</Typography>
								</Box>
							) : (
								<Box
									p={1}
									pr={5}
									width="100%"
									display={"flex"}
									justifyContent={"center"}>
									<FormControl fullWidth>
										<OutlinedInput
											fullWidth
											size="small"
											startAdornment={
												<InputAdornment position="start">
													<Search />
												</InputAdornment>
											}
											onChange={(e) => {
												handleSearch(e.target.value);
											}}
										/>
									</FormControl>
								</Box>
							)}
						</Box>
					)}
					<Box
						sx={{ display: "flex", alignItems: "center", gap: 1, mr: 2 }}
					>
						<Box>
							{
								isOnline ? (
									<Box
										sx={{
											display: "flex",
											alignItems: "center",
											gap: 1,
										}}
									>
										<OnlineIcon />
										<Typography
											sx={{ fontSize: 12, color: theme.palette.online_status.online }}
										>
											網絡連線正常
										</Typography>
									</Box>
								) : (
									<Box
										sx={{
											display: "flex",
											alignItems: "center",
											gap: 1,
										}}
									>
										<OfflineIcon />
										<Typography
											sx={{ fontSize: 12, color: "#FF2626" }}
										>
											離線
										</Typography>
									</Box>
								)
							}
						</Box>
						{/* <Box>
							{enableSearching && (
								<IconButton
									onClick={() => {
										triggerSearching();
									}}>
									{mode === "search" ? <Close /> : <Search />}
								</IconButton>
							)}
						</Box> */}
					</Box>
				</Toolbar>
			</AppBar>
		</>
	);
};

export default TopBar;
